import React, { useState, useEffect } from 'react';

export default function GalerieProduit({ produit }) {
  const images = produit?.media || [];
  const imagesToShow = images; // tu gardes ta logique si besoin
  const moreImages = Math.max(images.length - 6, 0);

  const [open, setOpen] = useState(false);
  const [selectedImg, setSelectedImg] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // (optionnel) fermer avec ECHAP
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') setOpen(false);
    }
    if (open) window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const styles = {
    overlay: {
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: 16,
    },
    modal: {
      background: '#fff',
      borderRadius: 10,
      maxWidth: '1000px',
      width: '95vw',
      maxHeight: '90vh',
      overflowY: 'auto',
      padding: '16px 16px 6px',
      position: 'relative',
    },
    close: {
      position: 'absolute',
      top: 10,
      right: 14,
      fontSize: 26,
      lineHeight: 1,
      cursor: 'pointer',
      color: '#333',
    },
    gridImg: {
      width: '100%',
      height: 180,
      objectFit: 'cover',
      borderRadius: 8,
      cursor: 'pointer',
    },
  };

  return (
    <>
      {/* ----- Tes miniatures existantes ----- */}
      {imagesToShow.slice(3, 6).map((img, i) => (
        <div className="col-3 col-md-2" key={i} style={{ marginTop: '1rem' }}>
          <img
            src={img.url}
            alt={`thumb-${i}`}
            className="img-fluid rounded w-100"
            style={{ objectFit: 'cover', height: '100px' }}
          />
        </div>
      ))}

      {/* ----- Overlay "+X autres photos" -> ouvre la modal ----- */}
      {moreImages > 0 && (
        <div
          className="col-3 col-md-2 position-relative"
          style={{ marginTop: '1rem', cursor: 'pointer' }}
          onClick={() => setOpen(true)}
          title="Voir toutes les photos"
        >
          <img
            src={produit?.media?.[6]?.url}
            alt="more"
            className="img-fluid rounded w-100"
            style={{ objectFit: 'cover', height: '100px' }}
          />
          <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center text-white fw-bold rounded"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', fontSize: '0.9rem' }}
          >
            +{moreImages} autres photos
          </div>
        </div>
      )}

      {/* ----- Modal maison ----- */}
      {open && (
        <div style={styles.overlay} onClick={() => setOpen(false)}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <span style={styles.close} onClick={() => setOpen(false)}>
              &times;
            </span>
            <h4 className="mt-3" style={{ color: 'red' }}>
              Galerie photos
            </h4>

            <div
              style={{
                position: 'fixed',
                inset: 0,
                backgroundColor: 'rgba(0,0,0,0.8)',
                zIndex: 1050,
                overflowY: 'auto',
              }}
              onClick={() => setOpen(false)} // clic en dehors = fermer
            >
              <div
                className="container py-4"
                style={{ position: 'relative', zIndex: 1100 }}
                onClick={(e) => e.stopPropagation()} // empêche fermeture si on clique sur une image
              >
                {/* Bouton fermer */}
                <button
                  onClick={() => setOpen(false)}
                  style={{
                    position: 'absolute',
                    top: '15px',
                    right: '25px',
                    fontSize: '2rem',
                    color: '#fff',
                    background: 'transparent',
                    border: 'none',
                  }}
                >
                  &times;
                </button>

                {/* Image sélectionnée en grand */}
                {selectedImg && (
                  <div className="text-center mb-4">
                    <img
                      src={selectedImg}
                      alt="preview"
                      style={{
                        maxHeight: '80vh',
                        maxWidth: '100%',
                        borderRadius: '8px',
                      }}
                    />
                  </div>
                )}

                <div className="row g-3">
                  {images.map((img, idx) => (
                    <div className="col-6 col-md-4 mb-3" key={idx}>
                      <img
                        src={img.url}
                        alt={`img-${idx}`}
                        style={styles.gridImg}
                        loading="lazy"
                        onClick={() => setSelectedImg(img.url)}
                      />
                    </div>
                  ))}
                </div>

                <div className="text-end py-2">
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => setOpen(false)}
                  >
                    Fermer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
